import { render, staticRenderFns } from "./AccountsId.vue?vue&type=template&id=dec8aafe&scoped=true&"
import script from "./AccountsId.vue?vue&type=script&lang=js&"
export * from "./AccountsId.vue?vue&type=script&lang=js&"
import style0 from "./AccountsId.vue?vue&type=style&index=0&id=dec8aafe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec8aafe",
  null
  
)

export default component.exports